import React from 'react'
import { ActivityIndicator } from 'react-native'

import { Stack } from '@zet/design-system'

import useAuthStore from '../../store/authStore'

const Splash = () => {
  const { isAuthenticated } = useAuthStore()

  if (isAuthenticated) {
    window.location.href = '/home'
  } else {
    window.location.href = '/verify-phone-number'
  }

  return (
    <Stack className="w-full flex-1 items-center justify-center">
      <ActivityIndicator />
    </Stack>
  )
}

export default Splash
